module.exports = __webpack_public_path__ + "img/marinade-for-grilled-shrimp.a45700a0.jpg";